module.exports = __webpack_public_path__ + "static/media/np.2e58af7b.svg";